import React from 'react';
import { useEsosa } from './EsosaContext';
import AssistantButton from './AssistantButton';
import ChatWindow from './ChatWindow';
const EsosaAssistant: React.FC = () => {
  const {
    isOpen
  } = useEsosa();
  return <>
      <AssistantButton data-id="element-266" />
      {isOpen && <ChatWindow data-id="element-267" />}
    </>;
};
export default EsosaAssistant;